import { connect } from 'react-redux';
import {
  setGroupingMode,
  setGroupingType,
  setGroupingFilter
} from '../actions/grouping';
import GroupFilterButton from '../components/GroupFilterButton';
import {
  GROUPING_CATEGORY_AREA,
  GROUPING_CATEGORY_EQUIPMENT,
  GROUPING_FILTER_AREA_FUNCTIONAL,
  GROUPING_FILTER_AREA_ROOM,
  GROUPING_FILTER_EQUIPMENT_DESCRIPTION,
  GROUPING_FILTER_EQUIPMENT_GROUP,
  GROUPING_FILTER_EQUIPMENT_TYPE,
  GROUPING_MODE_OFF
} from '../constants/actionTypes';

const mapStateToProps = (state, ownProps) => {
  const loading = state.app.loading;

  if (ownProps.mode === state.groupFilter.mode) {
    return { active: true, loading };
  }

  if (ownProps.mode) {
    return { active: false, loading };
  }

  if (state.groupFilter.mode === GROUPING_MODE_OFF) {
    return { active: false, hide: true, loading };
  }

  if (ownProps.hasOwnProperty('category')) {
    return ownProps.category === state.groupFilter.category
      ? { active: true, loading }
      : { active: false, loading };
  }

  if (state.groupFilter.category === GROUPING_CATEGORY_AREA) {
    if (
      ownProps.filter === GROUPING_FILTER_AREA_FUNCTIONAL ||
      ownProps.filter === GROUPING_FILTER_AREA_ROOM
    ) {
      return ownProps.filter === state.groupFilter.filter
        ? { active: true, loading }
        : { active: false, loading };
    }
  }

  if (state.groupFilter.category === GROUPING_CATEGORY_EQUIPMENT) {
    if (
      ownProps.filter === GROUPING_FILTER_EQUIPMENT_TYPE ||
      ownProps.filter === GROUPING_FILTER_EQUIPMENT_DESCRIPTION ||
      ownProps.filter === GROUPING_FILTER_EQUIPMENT_GROUP
    ) {
      return ownProps.filter === state.groupFilter.filter
        ? { active: true, loading }
        : { active: false, loading };
    } else {
      return { active: false, hide: true, loading };
    }
  }

  return { active: false, hide: true, loading };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  if (ownProps.mode) {
    return {
      onClick: () => {
        dispatch(setGroupingMode(ownProps.mode));
      }
    };
  }

  if (ownProps.category) {
    return {
      onClick: () => {
        dispatch(setGroupingType(ownProps.category));
      }
    };
  }

  return {
    onClick: () => {
      dispatch(setGroupingFilter(ownProps.filter));
    }
  };
};

const GroupLink = connect(mapStateToProps, mapDispatchToProps)(
  GroupFilterButton
);

export default GroupLink;



// WEBPACK FOOTER //
// ./src/container/GroupLink.js